<template>
  <div :class="['emd-form-group', `js${name}group`]">
    <label :class="['emd-label', required ? 'u-required' : '']">{{title}}</label>
    <input
      class="emd-input"
      type="number"
      ref="input"
      :required="required"
      :name="name"
      :value="value"
      :step="type === 'number' ? 'any': step"
      :min="min"
      :max="max"
      :placeholder="placeholder"
      @input="onInput"
      @change="handleInput"
    >
    <div :class="['emd-input-helper', `js${name}helper`]"></div>
  </div>
</template>
<script>
export default {
  name: 'EmdInputNumber',
  computed: {
    placeholder: function () {
      if (this.attrs !== undefined) {
        if (this.attrs.placeholder !== undefined) { return this.attrs.placeholder }
      }
      return this.title
    }
  },
  props: ['required', 'name', 'step', 'min', 'max', 'value', 'onInput', 'title', 'type', 'attrs'],
  methods: {
    handleInput (event) {
      this.$emit('input', Number(event.target.value))
    }
  }
}
</script>
<style scoped>
</style>
